import { classNames } from '@allurion/ui';

import styles from './CircularProgress.module.scss';

type Props = {
  className?: string;
};

export function CircularProgress({ className }: Props) {
  return <div className={classNames(styles.container, className)} />;
}
